import script from "./Badges.vue?vue&type=script&lang=ts&setup=true"
export * from "./Badges.vue?vue&type=script&lang=ts&setup=true"

import "./Badges.vue?vue&type=style&index=0&id=18f4dff5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18f4dff5"]])

export default __exports__